import { WHY_US } from "../../data/content";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";

export const WhyUs = () => (
    <section id="why-us" data-testid="why-us-section" className="py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-5 lg:px-10">
            <SectionHeading
                number="04"
                eyebrow="Why Choose Us"
                title="Care Built Around"
                accent="You"
            />
            <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                {WHY_US.map((f, i) => (
                    <Reveal key={f.title} delay={(i % 3) * 0.08}>
                        <div
                            data-testid={`why-us-card-${i}`}
                            className="group relative h-full overflow-hidden rounded-3xl border border-ink/10 bg-white p-8 transition-[box-shadow,transform] duration-500 hover:-translate-y-1.5 hover:shadow-[0_24px_50px_-20px_rgba(11,31,42,0.2)]"
                        >
                            <span className="pointer-events-none absolute -right-6 -top-8 font-display text-[7rem] font-light leading-none text-mist transition-colors duration-500 group-hover:text-teal-100">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <span className="relative grid h-12 w-12 place-items-center rounded-full bg-ink text-teal-300 transition-[background-color] duration-500 group-hover:bg-teal-accent group-hover:text-white">
                                <f.icon className="h-5 w-5" />
                            </span>
                            <h3 className="relative mt-6 font-display text-2xl leading-snug text-ink">{f.title}</h3>
                            <p className="relative mt-3 text-sm leading-relaxed text-slate-600">{f.desc}</p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
